/**
 * LoginPage.jsx
 *
 * Page de connexion avec Ant Design
 */

import React, { useState } from "react";
import { Form, Input, Button, Card, Space, message } from "antd";
import { useNavigate, Link } from "react-router-dom";
import { loginUser } from "../api/api";
import { useAuth } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";

/**
 * LoginPage - Connexion utilisateur
 */
export default function LoginPage() {
    const navigate = useNavigate();
    const { login: loginContext } = useAuth();
    const { isDarkMode } = useTheme();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const handleSubmit = async (values) => {
        try {
            setLoading(true);
            const res = await loginUser(values.login, values.password);
            loginContext(res.data.token, { login: values.login });
            message.success("Connexion réussie !");
            navigate("/");
        } catch (err) {
            message.error(err.response?.data?.error || "Erreur de connexion");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                padding: "16px",
                background: isDarkMode ? "#000000" : "#fafafa",
            }}
        >
            <Card
                style={{
                    width: "100%",
                    maxWidth: "400px",
                    background: isDarkMode ? "#1f1f1f" : "#ffffff",
                }}
            >
                <Space direction="vertical" style={{ width: "100%" }}>
                    <h2 style={{ textAlign: "center", margin: "0 0 24px" }}>
                        Connexion
                    </h2>

                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}
                    >
                        <Form.Item
                            label="Identifiant"
                            name="login"
                            rules={[{ required: true, message: "Requis" }]}
                        >
                            <Input placeholder="Ton identifiant" size="large" />
                        </Form.Item>

                        <Form.Item
                            label="Mot de passe"
                            name="password"
                            rules={[{ required: true, message: "Requis" }]}
                        >
                            <Input.Password placeholder="Ton mot de passe" size="large" />
                        </Form.Item>

                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            block
                            size="large"
                        >
                            Se connecter
                        </Button>
                    </Form>

                    <div style={{ textAlign: "center", fontSize: "14px" }}>
                        Pas de compte ?{" "}
                        <Link to="/register" style={{ color: "#1890ff" }}>
                            Créer un compte
                        </Link>
                    </div>
                </Space>
            </Card>
        </div>
    );
}